import React from 'react';
import Input from 'antd/es/input';
import Button from 'antd/es/button';
import Icon from 'antd/es/icon';
import Tag from 'antd/es/tag';
import Modal from 'antd/es/modal';
import { cloneDeep, get } from 'lodash-es';
import update from 'immutability-helper';

const Confirm = Modal.confirm;

const composeColumns = (columnProps, filterFunc) => {
  const columns = cloneDeep(columnProps);

  return columns
    .filter((entry) => entry.visible)
    .map((entry, index) => {
      if (index === 0) {
        // eslint-disable-next-line no-param-reassign
        entry = {
          ...entry,
          render: (text, record) => {
            if (record.new) {
              return (
                <>
                  <Tag color="#f50">New</Tag>
                  {' '}
                  {text}
                </>
              );
            }

            return text;
          },
        };
      }

      // handle date columns
      if (entry.type === 'date') {
        // eslint-disable-next-line no-param-reassign
        entry = {
          ...entry,
          render: (text) => {
            if (typeof text === 'object') {
              const startText = text ? text.start : '-';
              const endText = text ? text.end : '-';
              return `${startText} - ${endText}`;
            }
            return text;
          },
        };
      }

      // handle delete action
      if (entry.type === 'action') {
        // eslint-disable-next-line no-param-reassign
        entry = {
          ...entry,
          render: (text, record) => (
            <Button
              style={{ zIndex: 2 }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (typeof entry.func === 'function') {
                  Confirm({
                    title: 'Delete this item ?',
                    onOk() {
                      entry.func.call(this, record._id);
                    },
                    cancelText: 'Cancel',
                  });
                }
              }}
              type="danger"
              icon="delete"
              size="small"
            />
          ),
        };
      }

      // handle columns with sorters
      if (entry.sortDirections) {
        // eslint-disable-next-line no-param-reassign
        entry = {
          ...entry,
          sorter: (a, b) => a[entry.dataIndex]
            .toLowerCase()
            .localeCompare(b[entry.dataIndex].toLowerCase()),
        };
      }


      if (!entry.searchable) {
        return entry;
      }

      const input = React.createRef();

      // handle columns with search
      return {
        ...entry,
        filterDropdown: ({
        // eslint-disable-next-line react/prop-types
          setSelectedKeys, confirm, clearFilters,
        }) => (
          <div style={{ padding: 8 }}>
            <Input
              ref={input}
              placeholder="Search..."
            // value={selectedKeys[0]}
              onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={(e) => {
                if (filterFunc) {
                  filterFunc({ dataIndex: entry.dataIndex, search: e.target.value.toLowerCase() });
                }
              }}
              style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
            <Button
              type="primary"
              onClick={() => {
                filterFunc({ dataIndex: entry.dataIndex, search: input.current.state.value.toLowerCase() });
              }}
              icon="search"
              size="small"
              style={{ width: 90, marginRight: 8 }}
            >
            Search
            </Button>
            <Button
              onClick={() => {
                clearFilters();
                input.current.state.value = '';
              }}
              size="small"
              style={{ width: 90 }}
            >
            Reset
            </Button>
          </div>
        ),

        filterIcon: (filtered) => (
          <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),

        onFilter: (value, record) => get(record, entry.dataIndex, '')
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),

        onFilterDropdownVisibleChange: (visible) => {
          if (visible) {
            setTimeout(() => input.current.select());
          }
        },
      };
    });
};

export const addActionColumn = (columnProps, cb) => {
  const columns = cloneDeep(columnProps);

  return update(columns, {
    $push: [{
      title: 'Action',
      key: 'operation',
      fixed: 'right',
      width: 100,
      type: 'action',
      visible: true,
      func: cb,
    }],
  });
};

export default composeColumns;
